module.exports = __webpack_public_path__ + "img/ep-croix-1.52782550.jpg";